import React from 'react';
import Rockets from '../features/Rocket/Rocket';

const RocketPage = () => (
  <div>
    <Rockets />
  </div>
);

export default RocketPage;
